<template>
    <v-container grid-list-sm text-xs-left>
        <v-toolbar flat color="white">
            <v-toolbar-title>Synonyms Management</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-flex xs12 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="addSynonym">Add Synonym</v-btn>
        </v-toolbar>
        <v-data-table
                hide-actions
                :headers="headers"
                :search="search"
                :items="synonym_items"
                class="elevation-1"
        >
            <template v-slot:items="props">
                <td class="justify-center align-center layout px-0 pt-2">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(props.item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteIcon(props.item)"
                    >
                        delete
                    </v-icon>
                </td>
                <td class="text-xs-center">{{ props.item.basic_word }}</td>
                <td class="text-xs-center">{{ props.item.synonyms }}</td>
            </template>
        </v-data-table>

        <!-- Dialog: Delete confirm -->
        <v-dialog
                v-model="dialogDeleteConfirm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Deletion confirmation</span>
                </v-card-title>

                <v-card-text>
                    <v-flex>
                        <span class="subheading">Are you sure you want to delete this synonyms?</span>
                    </v-flex>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            round
                            color="red"
                            flat
                            @click="dialogDeleteConfirm=false"
                    >
                        NO
                    </v-btn>
                    <v-btn
                            round
                            color="green"
                            flat
                            @click="deleteSynonym()"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- New user -->
        <v-dialog
                v-model="newSynonymDialog"
                max-width="800px"
        >
            <v-card>
                <v-card-title>
                    <span class="headline">{{newSynonymDialogText}}</span>
                </v-card-title>

                <v-card-text>
                    <NewSynonym ref="newSynonym" @submit="closeDialog"></NewSynonym>
                    <!--<NewUser ref="newUser" @submit="closeDialog"></NewUser>-->
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import NewSynonym from "@/components/Tables/NewSynonym";

    export default {
        name: "SynonymTable",
        components: {NewSynonym},
        data() {
            return {
                newSynonymDialogText: "",
                newSynonymDialog: false,
                headers: [
                    {text: "Actions", value: "action", align: "center", sortable: false,},
                    {text: 'Basic Word', align: "center", value: 'basic_word' },
                    {text: 'Synonyms', align: "center", value: 'synonyms' },
                ],
                synonym_items:[],
                itemToDelete: null,
                dialogDeleteConfirm: false,
                search:""
            }
        },

        created(){
            this.getSynonyms();
        },

        methods: {
            closeDialog(){
                this.newSynonymDialog = false;
                this.getSynonyms(this.page)
            },
            addSynonym(){
                this.newSynonymDialogText = "Add Synonym";
                this.newSynonymDialog = true;
                this.$refs.newSynonym.clear();
                this.$refs.newSynonym.setSynonym(true);
            },
            editItem(item){
                this.newSynonymDialogText = "Edit Synonym";
                this.newSynonymDialog = true;
                this.$refs.newSynonym.fillFields(item);
                this.$refs.newSynonym.setSynonym(false);
            },
            deleteSynonym(){
                this.dialogDeleteConfirm = false;
                //this.getUsers(this.page)
                let id = this.itemToDelete.id;
                let requestUrl = {
                    url: UrlsService.synonymsOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        synonymRequest: {
                            synonym:{
                                _id:id
                            },
                            operation: "delete"
                        }
                    }
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Reading synonyms",
                    loading: "Reading",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.getSynonyms();
                    });
                /*let requestUrl = {
                    url: UrlsService.user + '/'+ this.itemToDelete.id,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "delete",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Delete user",
                    loading: "Delete user",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.dialogDeleteConfirm = false;
                        this.getUsers(this.page)

                    });*/

            },
            deleteIcon(item) {
                this.dialogDeleteConfirm = true;
                this.itemToDelete = item;
            },
            getSynonyms(){
                this.synonym_items = []
                let requestUrl = {
                    url: UrlsService.synonymsOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        synonymRequest: {
                            operation: "read"
                        }
                    }
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Reading synonyms",
                    loading: "Reading",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.registrationStatus = true;
                            console.log(response)
                            let synonyms = response.response.synonym
                            for(let i=0;i<synonyms.length;i++){
                                let s = {
                                    id :synonyms[i]._id,
                                    basic_word : synonyms[i].basic_word,
                                    synonyms : synonyms[i].synonyms
                                }
                                this.synonym_items.push(s)
                            }
                    });


                /*let requestUrl = {
                    url: UrlsService.user + '?page=' + page + '&size=' + this.pageSize,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "get",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get users",
                    loading: "Get users",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        //this.users = response;
                        let usersComplete = [];
                        for (let i = 0; i < response.length; i++){
                            usersComplete.push(response[i])

                        }
                        this.users = response.filter(function (el) {
                            return el.roleId === 6 || el.roleId === 7 || el.roleId === 9
                        });
                        if(this.users.length === 0){
                            this.maxPage = this.page - 1;
                            this.getUsersDown();
                        }
                        if(usersComplete.length < this.pageSize || this.page === this.maxPage){
                            this.disableUsersUp = true;
                        }
                        else {this.disableUsersUp = false;}
                    });*/


            }
        },
    };
</script>

<style lang="scss">
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }
</style>

